module.exports = __webpack_public_path__ + "a456494055bc9c888a2826ead600d417.jpg";